// extracted by mini-css-extract-plugin
module.exports = {"container":"Governance_container__11svk","nav":"Governance_nav__l2_Bt","content":"Governance_content__vNNE3"};